var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layer-item",attrs:{"id":`layer-item-${_vm.layer.initial.id}`}},[_c(_vm.layer.description.name,_vm._b({tag:"component",attrs:{"event":_vm.formatEventData(_vm.layer.event),"initial":_vm.layer.initial}},'component',_vm.layer.initial.props,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }